import { faFolder } from "@fortawesome/pro-solid-svg-icons"
import { IApiFunc, IApiResult } from "auth/interface/api.interface"
import { useApi } from "auth/useApi3"
import { apiEndpoints } from "generated/apiEndpoints"
import { t } from "i18next"
import React, { useEffect, useRef, useState } from "react"
import { IDocumentFolder, IDocumentFormValues } from "../../interface/folder.interface"
import { folderValidationSchema } from "../folderValidationSchema"
import { Sidebar } from "components/sidedrawer/Sidebar2"
import { DocumentForm } from "pages/documents/components/Form/DocumentForm"

const FolderForm = (props: IDocumentFormValues) => {
  const { formValues, handleSubmit, results } = props
  const { id, body, companyIds, customRoleIds, cretedDate } = formValues as IDocumentFolder
  const [roleResult, listRoleApi] = useApi() as [IApiResult, IApiFunc]
  const [initialFormikValues, setInitialFormikValues] = useState(formValues)
  const formRef = useRef<any>(null)

  useEffect(() => {
    listRoleApi.get(apiEndpoints.customeradmin.getcustomercustomroles)
  }, [])

  useEffect(() => {
    if (results.status === 2 && formRef.current) {
      formRef.current.resetForm()
    }
  }, [results])

  return (
    <Sidebar
      initialFormikValues={formValues}
      setInitialFormikValues={setInitialFormikValues}
      validationSchema={folderValidationSchema(t)}
      handleSubmit={handleSubmit}
      formResult={results}
      formData={{
        formId: "DocumentsForm",
        icon: faFolder,
        titleNew: t(`documents.add_button`, "Add Folder"),
        subTitleNew: "",
        titleEdit: t(`documents.edit_button`, "Edit folder"),
        subTitleEdit: "",
        submitText: t(`documents.folder_form.create_button`, "Create folder"),
        submitEditText: t(`documents.folder_form.save_button`, "Save settings")
      }}
      formRef={formRef}
    >
      <DocumentForm
        id={id}
        cretedDate={cretedDate}
        body={body}
        results={results}
        roleResult={roleResult}
      />
    </Sidebar>
  )
}

export default FolderForm
